<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<form  [formGroup]="form" novalidate *ngIf="loadInfo" @fadeInAnimation>
  <p class="text-info">
    Por favor califica cada una de las siguientes afirmaciones sobre tu estado actual del 1 al 6 utilizando la siguiente escala.
  </p>

  <div nz-row class="mt-xs mb-md tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100  tw-w-full">
    <div nz-col [nzXs]="24" [nzMd]="12">
      <p class="text-info-bold mb-xs">1. Fuertemente en desacuerdo</p>
    </div>
    <div nz-col [nzXs]="24" [nzMd]="12">
      <p class="text-info-bold mb-xs">2. Moderadamente en desacuerdo</p>
    </div>
    <div nz-col [nzXs]="24" [nzMd]="12">
      <p class="text-info-bold mb-xs">3. Medianamente en desacuerdo</p>
    </div>
    <div nz-col [nzXs]="24" [nzMd]="12">
      <p class="text-info-bold mb-xs">4. Medianamente de acuerdo</p>
    </div>
    <div nz-col [nzXs]="24" [nzMd]="12">
      <p class="text-info-bold mb-xs">5. Moderadamente de acuerdo</p>
    </div>
    <div nz-col [nzXs]="24" [nzMd]="12">
      <p class="text-info-bold mb-xs">6. Fuertemente de acuerdo</p>
    </div>
  </div>

  <div class=""> <!-- tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mt-3 tw-w-full -->
    <div nz-row [nzGutter]="[30, 15]">
      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">1. Estoy físicamente saludable.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="physicallyHealthy"  [nzMarks]="marks" [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('physicallyHealthy').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('physicallyHealthy')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">2. Me siento en control de mi salud física.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="wellPhysicalHealthControl" [nzMarks]="marks" [nzDots]="true"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('wellPhysicalHealthControl').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('wellPhysicalHealthControl')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">3. Estoy satisfecho con mi peso.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="satisfiedWithMyWeight" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('satisfiedWithMyWeight').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('satisfiedWithMyWeight')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">4. Tengo suficiente energía para hacer las cosas que necesito hacer.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="enoughEnergyToDoMyThings"  [nzMarks]="marks" [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('enoughEnergyToDoMyThings').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('enoughEnergyToDoMyThings')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">5. Cuido mucho mi salud física.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="takeCareMyPhysicalHealth"  [nzMarks]="marks" [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('takeCareMyPhysicalHealth').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('takeCareMyPhysicalHealth')"></app-message-field>
      </div>


      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">6. Planeo para el futuro.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="planMyFuture" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('planMyFuture').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('planMyFuture')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">7. Me siento seguro de que soy capaz de resolver la mayoría de los problemas que enfrento.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="ableToSolveProblems" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('ableToSolveProblems').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('ableToSolveProblems')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">8. Estoy satisfecho con mi apariencia física.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="satisfiedWithMyPhysicalAppearance" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('satisfiedWithMyPhysicalAppearance').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('satisfiedWithMyPhysicalAppearance')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">9. Creo que tengo el potencial para alcanzar mis metas.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="potentialToReachMyGoals" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('potentialToReachMyGoals').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('potentialToReachMyGoals')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">10. Creo que puedo hacer una diferencia en la vida de los demás.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="makeADifferenceInOtherLives" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('makeADifferenceInOtherLives').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('makeADifferenceInOtherLives')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">11. Me gusta entablar conversaciones estimulantes.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="engageStimulatingConversations" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('engageStimulatingConversations').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('engageStimulatingConversations')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">12. La vida tiene sentido para mí.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="lifesMakesSense" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('lifesMakesSense').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('lifesMakesSense')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">13. Estoy satisfecho con mi espiritualidad.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="satisfiedSpiritually" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('satisfiedSpiritually').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('satisfiedSpiritually')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">14. Creo que soy tan inteligente o más inteligente que los demás.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="smartThanOthers" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('smartThanOthers').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('smartThanOthers')"></app-message-field>
      </div>

      <div nz-col [nzXs]="24" [nzMd]="24" [nzLg]="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">15. A menudo hago cosas que sacan a relucir mi lado creativo.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="bringOutMyCreativeSide" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('bringOutMyCreativeSide').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('bringOutMyCreativeSide')"></app-message-field>
      </div>
    </div>

    <!-- EnrichingActivities -->
    <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
      <div nz-row [nzGutter]="[30, 30]">
        <div nz-col nzXs="24" nzMd="8">
          <label nz-checkbox formControlName="hasEnrichingActivity" class="tw-flex tw-items-center">
            <div class="tw-flex tw-items-center">
              <img src="./../../../assets/images/icons/icons8-activities-64.png" class="tw-w-8 tw-mr-2" alt="">
              <p class="text-info">Actividades enriquecedoras</p>
            </div>
          </label>
        </div>
        <div nz-col nzXs="24" nzMd="8">
          <nz-select [nzDisabled]="!form.get('hasEnrichingActivity').value" formControlName="enrichingActivity" nzBorderless class="tw-w-full" [nzDropdownRender]="renderTemplateMoreOptionRegimen">
            <nz-option *ngFor="let activity of enrichingActivities" [nzValue]="activity" [nzLabel]="activity"></nz-option>
          </nz-select>
          <ng-template #renderTemplateMoreOptionRegimen>
            <nz-divider style="margin: 5px 0;"></nz-divider>
            <div class="container-more-option">
              <input type="text" nz-input #inputElement placeholder="Otra opción" />
              <a class="add-item" (click)="onAddOtherNutritionalRegimen(inputElement)">
                <button nz-button nzType="default" class="btn-default"><i nz-icon nzType="plus" nzTheme="outline"></i></button>
              </a>
            </div>
          </ng-template>
        </div>
        <div nz-col nzXs="24" nzMd="8">
          <div class="tw-flex tw-items-center tw-justify-between">
            <p class="text-info tw-mr-2">¿Cuántos días a la semana?</p>
            <nz-input-number [nzDisabled]="!form.get('hasEnrichingActivity').value" [nzMin]="0" [nzMax]="7" formControlName="enrichingActivityFrequency" style="max-width: 60px;"></nz-input-number>
          </div>
        </div>
      </div>
    </div>
    <!-- / EnrichingActivities -->

  </div>
</form>

<div class="d-flex justify-content-end" *ngIf="!(this.isPatient$ | async)">
  <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
</div>

